import { Container } from 'inversify-props';
import setupInvestorGoalScheduledDistributionSowosWealth from './sowos-wealth/setup';
import setupInvestorGoalScheduledDistributionSowosPocketWithdrawal from './sowos-pocket/withdrawal/setup';

export default function setupInvestorGoalScheduledDistributionModule(container: Container) {
  setupInvestorGoalScheduledDistributionSowosWealth(container);
  setupInvestorGoalScheduledDistributionSowosPocketWithdrawal(container);
}
